import { useMutation, useQueryClient } from '@tanstack/react-query';
import { DatasetUpdateAPISchema } from '@rossum/mdh-api-client';
import { datasetApi, getDatasetRequestConfig } from '../api';
import { TABLES_QUERY } from './useTables';

export const useUpdateTable = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      tableName,
      table,
    }: {
      tableName: string;
      table: DatasetUpdateAPISchema;
    }) => {
      return datasetApi.updateDatasetApiV2DatasetsDatasetNamePatch(
        tableName,
        table,
        getDatasetRequestConfig()
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: TABLES_QUERY,
      });
    },
  });
};
